import React, { Component } from "react";
import { Modal, Form, Input, Select, DatePicker } from "antd";
import moment from "moment";
import http from "../../../axios/http";
import server from "../../../axios/server";

const FormItem = Form.Item;


class PlateNoBlackEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = { parkZones: [] };
  }

  onDateChange = (item, val) => {
    this.props.editData.expireDate = val;
  };

  loadAllZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };
  componentWillMount() {
    this.loadAllZone();
  }

  save = () => {
    const { editData, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (editData.id) values["id"] = editData.id;
      values["state"] = -1;
      values["expireDate"] = editData.expireDate;
      values["useZone"] = values.useZoneArr.join(",");
      delete values.useZoneArr;
      http.post({
        url: "/barrier/plateNoCard/save",
        data: values,
        success: (res) => {
          http.post({
            url:server.mallServerUrl+"/externalApi/barrier/updatePlateNoWLCache",
            data: { plateNo: editData.plateNo },
            success: (res) => {
              console.log("mallapi白名单缓存刷新成功");
            },
          });
          this.props.successCallback(this.props.queryData);
          this.props.onCancel();
        },
      });
    });
  };

  render() {
    const { visible, onCancel, form, editData } = this.props;
    const { getFieldDecorator } = form;
    const { parkZones } = this.state;
    return (
      <Modal
        visible={visible}
        title="黑名单编辑"
        okText="保存"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
        afterClose={() => {
          this.props.form.resetFields();
        }}
      >
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="车牌号：">
            {getFieldDecorator("plateNo", {
              rules: [
                { required: true, message: "请输入车牌号!" },
                { max: 10, message: "最多只能输入10个字符！" },
              ],
              initialValue: editData.plateNo,
            })(<Input />)}
          </FormItem>
          <FormItem label="备注：">
            {getFieldDecorator("remark", {
              rules: [{ max: 30, message: "最多只能输入30个字符！" }],
              initialValue: editData.remark,
            })(<Input />)}
          </FormItem>
          <FormItem label="有效期至：">
            {getFieldDecorator("expireDate", {
              rules: [{ required: true, message: "请输入有效期" }],
              initialValue: moment(editData.expireDate, "YYYY-MM-DD"),
            })(
              <DatePicker onChange={this.onDateChange} placeholder="有效期至" />
            )}
          </FormItem>
          <FormItem label="生效场地：">
            {getFieldDecorator("useZoneArr", {
              initialValue: editData.useZoneArr,
            })(
              <Select mode="multiple">
                {parkZones &&
                  parkZones.map((item, index) => (
                    <Select.Option key={item.id} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const PlateNoBlackEdit = Form.create()(PlateNoBlackEditForm);

export default PlateNoBlackEdit;
